module.exports = __webpack_public_path__ + "static/factory-43f6293bbb1e456c73c3f731fb7a8c50.svg";